import React from "react";
import styled from "styled-components";

import Github from "../../img/icons/github-black.svg";
import LinkedIn from "../../img/icons/LI-In-Bug.png";
import Email from "../../img/icons/mail-black.svg";

const Contact = () => {
  return (
    <Wrapper>
      <Item>
        <Image src={Email} />
        Email:&nbsp;
        <a href="mailto:genechanemail@gmail.com" target="_blank">
          GeneChanEmail@gmail.com
        </a>
      </Item>
      <Item>
        <Image src={Github} />
        Github:&nbsp;
        <a href="https://github.com/genechan" target="_blank">
          https://github.com/genechan
        </a>
      </Item>
      <Item>
        <Image src={LinkedIn} />
        LinkedIn:&nbsp;
        <a href="https://www.linkedin.com/in/gene-chan/" target="_blank">
          https://www.linkedin.com/in/gene-chan/
        </a>
      </Item>
    </Wrapper>
  );
};

const Wrapper = styled.ul`
  padding: 0;
  width: 35em;
  display: block;
  margin: 12em auto;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: xxx-large;
    width: 90%;
    margin: 2em auto;
    font-weight: bolder;
    & a {
      display: block;
      font-size: xx-large;
    }
  }
`;
const Item = styled.li`
  list-style: none;
  padding: 1em;
  border: 1px solid;
  margin: 1em 0;
  position: relative;
  background-color: var(--clouds);
`;
const Image = styled.img`
  width: 2.5em;
  height: 2.5em;
  margin: 0 1em;
  position: absolute;
  left: 0;
  top: 0.5em;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    width: 1.75em;
    height: 1.75em;
    left: -15px;
  }
`;
export default Contact;
